import React, { useEffect } from "react";
import { Container } from "./Container";
import "./styles.scss";
import cart from "../../images/cart.png";

const CardSmall = (props) => {
  const {
    cardLeft,
    cardRight,
    item,
    price,
    desc,
    photo,
    action,
    like,
    soldout,
    oldPrice,
    discount,
    favourite
  } = props;

  const addDefaultSrc = (e) => {
    e.target.src = cart;
  };
  return (
    <Container>
      <div className="card-item">
        <div className="card-item-body" >
          <div className="d-flex justify-content-between">
            <div className="heart-container" onClick={favourite}>
              {like ? (
                <span style={{ color: "#0279B8" }}>
                  <i className="fa fa-heart" aria-hidden="true"></i>
                </span>
              ) : (
                <i className="fa fa-heart-o" aria-hidden="true"></i>
              )}
            </div>
            <div className="item-small-image-container" onClick={action}>
              <img
                src={photo}
                className="card-item-image-container rounded"
                width="100%"
                alt="deal day"
                onError={addDefaultSrc}
              />
            </div>
            <div>{cardRight}</div>
          </div>
          <div onClick={action}>
            <p className="card-item-item-name">{item}</p>
            <p className="card-item-item-desc">{desc}</p>
            <p className="card-item-item-name">₦ {price}</p>
            <p className="card-item-item-name"><del>₦ {oldPrice}</del>{" "} <span className="discount">-{discount}%</span></p>
            {soldout ? (
              <p className="text-danger text-item pt-2">SOLD OUT</p>
            ) : (
              <p className="text-primary text-item pt-2">ADD TO CART</p>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CardSmall;
